import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AlarmIcon = (props: IconProps) => (
  <Icon width="17px" height="17px" viewBox="0 0 17 17" {...props}>
    <path d="M2.125 6.37499V10.625H4.95833L8.5 14.1667V2.83332L4.95833 6.37499H2.125ZM7.08333 6.25457V10.7454L5.54625 9.20832H3.54167V7.79165H5.54625L7.08333 6.25457ZM11.6875 8.49999C11.6875 7.24624 10.965 6.16957 9.91667 5.6454V11.3475C10.965 10.8304 11.6875 9.75374 11.6875 8.49999ZM9.91667 2.2879V3.74707C11.9637 4.35624 13.4583 6.25457 13.4583 8.49999C13.4583 10.7454 11.9637 12.6437 9.91667 13.2529V14.7121C12.7571 14.0675 14.875 11.5317 14.875 8.49999C14.875 5.46832 12.7571 2.93249 9.91667 2.2879Z" />
  </Icon>
);

export default memo(AlarmIcon);
